import React from "react";
import {ApplicationContext} from "cad/context";

export const ReactApplicationContext: React.Context<ApplicationContext> = React.createContext(null);